import { useEffect, useState } from "react";
import { ApiRequest } from "GlobalFunctions";
import { useSnackbar } from "notistack";
import 'assets/css/main.css'; // Asegúrate de tener las clases CSS definidas aquí
import ISwitch from "elements/ISwitch";
import MenuTaxes from "./MenuTaxes";
import AutocompleteField from "elements/AutocompleteField";
import AutocompleteField_su from "elements/AutocompleteField_su";

const defaultValues = {
    is_included: false,
    default_tax_category_id: '',
    default_taxjar_category_id: ''
};

export default function Taxes(props: any) {

    const { setLoading } = props;
    const { enqueueSnackbar } = useSnackbar();
    const [formValues, setFormValues] = useState<any>({});
    const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true);

    /*==========================================
    GET TAXES CONFIGURATION
    ==========================================*/
    const getTaxesConfiguration = async () => {
        await ApiRequest({
            method: 'GET',
            url: '/taxes/storeTaxesConfig',
            query: { store_id: localStorage.getItem('store_id') },
            setResponse: (res: any) => {
                setFormValues(res);
                setIsInitialLoad(false); // Mark that initial load is complete
            },
        });
        setLoading(false);
    }

    useEffect(() => {
        getTaxesConfiguration();
    }, []);
   

    /*==========================================
    UPDATE INCLUDED TAXES
    ==========================================*/
    const updateStoreTaxesConfig = (updatedValues: any) => {
        ApiRequest({
            method: 'POST',
            url: '/taxes/updateStoreTaxesConfig',
            body: { 
                store_id: localStorage.getItem('store_id'),
                ...updatedValues,
            },
            setResponse: (res: any) => {
                enqueueSnackbar("Included taxes updated successfully", { variant: "success" });
            }
        });
    }

    console.log("formValues", formValues);


    return (
        <div className='ModuleContainer'>
            <div className="ModuleHeader">
                <div className="ComponentTitle">
                    <h1>Tax Rates</h1>
                </div>

                <MenuTaxes />

                <div className="ModuleActions">

                </div>
            </div>

            <div id='taxes_content' className='ModuleContent'>
                <div className="ModuleSection">
                    <span className="account_label">Included Taxes</span>
                    <p>If your product prices already include tax, Penni Cart will automatically back-calculate the tax portion using this formula:
                        Tax amount = (Tax Rate × Price with Tax) / (1 + Tax Rate) So, if your price is $20 and your tax rate is 20%, we’ll calculate (20 × 0.20) / (1 + 0.20) = $3.33</p>
                    <ISwitch
                        label={formValues.is_included ? "On" : "Off"}
                        checked={formValues.is_included || defaultValues.is_included}
                        onChange={(e:any) => {
                            const newValue = e.target.checked;
                            const updatedValues = { ...formValues, is_included: newValue };
                            setFormValues(updatedValues);
                            if (!isInitialLoad) {
                                updateStoreTaxesConfig(updatedValues);
                            }
                        }}
                    />
                </div>

                <div className="ModuleSection">
                    <span className="account_label">Default Tax Category</span>
                    <p className="ModuleSection_subtitle">This is the default tax category that will be applied to all new products. You can update categories at any time.</p>
                    
                    <AutocompleteField
                        endpoint="/admin/taxes/categories/list"
                        label="Select Tax Category"
                        size="small"
                        value={formValues.default_tax_category_id || ''}
                        onChange={(data: any) => {
                            const updatedValues = { ...formValues, default_tax_category_id: data?.value || '' };
                            setFormValues(updatedValues);
                            if (!isInitialLoad) {
                                updateStoreTaxesConfig(updatedValues);
                            }
                        }}
                        fullWidth
                        dynamic={false}
                    />
                </div>




            </div>
        </div>
    );
}
